import { render } from "./Puntos.vue?vue&type=template&id=711f8b3a"
import script from "./Puntos.vue?vue&type=script&lang=js"
export * from "./Puntos.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__